import { AnimatedSection } from '@denqfabrik/landing-ui';
import { useTranslation } from '../../i18n';

export default function MuscleMemorySection() {
  const { t } = useTranslation();
  const { label, heading, headingHighlight, description, steps, caption } = t.muscleMemory;

  return (
    <section id="muscle-memory" data-nav-theme="light" className="bg-[#f2f5fa] py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <AnimatedSection>
          <div className="mx-auto mb-14 max-w-3xl text-center">
            <p className="mb-4 text-sm font-semibold uppercase tracking-[0.2em] text-teal-500">
              {label}
            </p>
            <h2 className="font-display text-4xl font-bold tracking-tight text-slate-900 md:text-5xl lg:text-6xl">
              {heading}{' '}
              <span className="bg-gradient-to-r from-sky-400 to-blue-500 bg-clip-text text-transparent">
                {headingHighlight}
              </span>
            </h2>
            <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-600">
              {description}
            </p>
          </div>
        </AnimatedSection>

        {/* Growing safety net visualization */}
        <AnimatedSection delay={100}>
          <div className="mx-auto max-w-2xl">
            <div className="rounded-[18px] border border-[#dce2eb] bg-white p-5 shadow-sm sm:p-8">
              <div className="space-y-4">
                {steps.map((step, i) => {
                  const widthPercent = Math.min(20 + i * 27, 100);
                  return (
                    <div key={i} className="group">
                      <div className="mb-1.5 flex items-baseline justify-between">
                        <div className="flex items-center gap-2">
                          <span className="text-xs font-bold text-teal-500 sm:text-sm">
                            {step.number}
                          </span>
                          <span className="text-xs text-slate-500 sm:text-sm">{step.label}</span>
                        </div>
                        <span className="text-xs font-semibold text-slate-700 sm:text-sm">
                          {step.checks}
                        </span>
                      </div>
                      <div className="h-3 overflow-hidden rounded-full bg-slate-100 sm:h-4">
                        <div
                          className="h-full rounded-full bg-gradient-to-r from-teal-400 to-emerald-400 transition-all duration-1000 ease-out"
                          style={{ width: `${widthPercent}%` }}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Caption */}
              <p className="mt-6 text-center text-xs text-slate-400 sm:text-sm">
                {caption}
              </p>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
